import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';

// Create Task Board
export const createTaskBoard = createAsyncThunk(
  'taskBoard/create',
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.post('/taskboard', data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create task board');
    }
  }
);

// Fetch All Task Boards
export const fetchTaskBoards = createAsyncThunk(
  'taskBoard/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get('/taskboard');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch task boards');
    }
  }
);

// Fetch Task Board by ID
export const fetchTaskBoardById = createAsyncThunk(
  'taskBoard/fetchById',
  async (taskBoardId: number, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/taskboard/${taskBoardId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch task board');
    }
  }
);

// Update Task Board
export const updateTaskBoard = createAsyncThunk(
  'taskBoard/update',
  async ({ taskBoardId, ...data }: any & { taskBoardId: number }, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.put(`/taskboard/${taskBoardId}`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update task board');
    }
  }
);

// Delete Task Board
export const deleteTaskBoard = createAsyncThunk(
  'taskBoard/delete',
  async (taskBoardId: number, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.delete(`/taskboard/${taskBoardId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete task board');
    }
  }
);
